<script>
import FeatureSelect from '@/components/cars/edit/FeatureSelect.vue'
import { DATE_SOURCES } from '@/components/service/shared'

export default {
  components: {
    'mia-feature-select': FeatureSelect
  },

  computed: {
    dateSource() {
      return this.$store.state.service.filters.global.dateSource
    }
  },

  created() {
    if (!this.dateSource) {
      this.$store.commit('service/setGlobalDateSource', DATE_SOURCES.firstTimestampDate)
    }
  },

  methods: {
    onInput(dateSource) {
      this.$store.commit('service/setGlobalDateSource', dateSource)

      this.$nextTick(() => {
        this.$emit('change')
      })
    }
  }
}
</script>

<template>
  <mia-feature-select
    :value="dateSource"
    label="Datumsbezug"
    @input="onInput"
  >
    <template #options>
      <option value="first_timestamp_date">
        1. Stempeldatum
      </option>
      <option value="invoice_date">
        Rechnungsdatum
      </option>
    </template>
  </mia-feature-select>
</template>
